import * as ng from 'angular';
import * as uib from 'angular-ui-bootstrap';
import * as _ from 'underscore';

import { TimeSlotsApi, TimeSlotsApiFactory } from './timeslots-api.service';
import { TimeSlot } from '../shared/time-slot.model';
import { GuestType } from '../../guest-type';
import { ReportsService } from '../../report/reports.service';
import { Event } from '../events-api.service';

export class TimeslotsListController {
   static $inject = ['timeSlotsApi', '$uibModal', 'toast', 'ReportsService', 'session', 'dialogs'];
   constructor(
      private timeSlotsApiFactory:TimeSlotsApiFactory,
      private $modal:uib.IModalService,
      private toast,
      private reportsService:ReportsService,
      private session,
      private dialogs
   ) { }

   event:Event;
   guestTypes:GuestType[];
   timeSlotsApi:TimeSlotsApi;
   timeslots:TimeSlot[];
   loading = false;
   campaignId: number;
   regTotals: any[]; // store pre-registration totals

   $onInit() {
      this.campaignId = this.session.getCampaign().id;
   }

   $onChanges(changesObj:ng.IOnChangesObject) {
      if (changesObj.event && changesObj.event.currentValue) {
         if (this.event.id) {
            this.timeSlotsApi = this.timeSlotsApiFactory(this.event.id);
            this.reload();
         }
      }
   }

   reload() {
      this.loading = true;

      this.reportsService.data('prereg-total', {
         'campaignId': this.campaignId,
         'eventIds': this.event.id
      }).then(response => {
         this.regTotals = response.data as any[];
      });

      return this.timeSlotsApi.list()
         .then(timeslots => this.timeslots = timeslots)
         .finally(() => this.loading = false);
   }

   private errorOnSave(error) {
      this.loading = false;
      this.toast.error()
         .message('There was a problem saving the time slot, please contact support.')
         .send();
   }

   add(dup:TimeSlot = null) {
      let newTimeslot:any = {};
      if (dup) {
         for (let key of _.keys(dup)) {
            newTimeslot[key] = dup[key];
         }
      }

      this.$modal.open({
         component: 'timeSlotEditor',
         resolve: { 
            timeslot: () => { return newTimeslot; },
            guestTypes: () => this.guestTypes,
            event: () => this.event
         }
      }).result.then((timeslot) => {
         this.loading = true;
         this.timeSlotsApi.create(timeslot)
            .then(() => this.reload())
            .catch(error => this.errorOnSave(error));
      });
   }

   edit(timeslot:TimeSlot) {
      this.$modal.open({
         component: 'timeSlotEditor',
         resolve: { 
            timeslot: () => timeslot,
            guestTypes: () => this.guestTypes,
            event: () => this.event
         }
      }).result.then((updated) => {
         this.loading = true;
         this.timeSlotsApi.update(updated)
            .then(() => this.reload())
            .catch(error => this.errorOnSave(error));
      });
   }

   remove(timeslot:TimeSlot) {
      let dateString = new Date(timeslot.startDateTime).toDateString() + " " + new Date(timeslot.startDateTime).toTimeString();

      let message = timeslot.name ? 
         `Are you sure you want to delete "${timeslot.name}" starting at ${dateString}?` :
         `Are you sure you want to delete this timeslot starting at ${dateString}?`;

      this.dialogs.confirm(message).then(() => {
         this.loading = true;
         this.timeSlotsApi.del(timeslot)
            .then(() => this.reload())
            .finally(() => this.loading = false)
            .catch(e => {
               if (e.status == 400) {
                  this.dialogs.alert('Unable to delete this timeslot');
               } else if (e.status == 409) {
                  this.dialogs.alert('Unable to delete this timeslot with existing pre-registration(s)');
               }
            });
      });
   }

   getOpenSpots(timeslot:TimeSlot, guestTypeSlug: string) {
      let regTotal = this.regTotals.find(t => {
            return t['timeslotId'] == timeslot.id && t['guestTypeSlug'] == guestTypeSlug;
      });
      return regTotal ? regTotal['spotsAvailable'] ?? '0' : '0';
   }

   getRegistered(timeslot:TimeSlot, guestTypeSlug: string) {
      let regTotal = this.regTotals.find(t => {
         return t['timeslotId'] == timeslot.id && t['guestTypeSlug'] == guestTypeSlug;
      });
      return regTotal ? regTotal['totalPreReg'] ?? '0' : '0';
   }

}

ng.module('e360').component('timeslotsList', {
   templateUrl: require('./timeslots-list.html'),
   controller: TimeslotsListController,
   bindings: {
      event: '<',
      guestTypes: '<'
   }
});
